import type { IconSvgObject } from './types';

const FileAttachmentIcon: IconSvgObject = [
  ["path", { d: "M14 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 8.23077V5.46154C4 3.54978 5.567 2 7.5 2C9.433 2 11 3.54978 11 5.46154V9.26923C11 10.2251 10.2165 11 9.25 11C8.2835 11 7.5 10.2251 7.5 9.26923V5.46154", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileAttachmentIcon;
